import { render, staticRenderFns } from "./Dev.vue?vue&type=template&id=63c92e78&lang=pug&"
import script from "./Dev.vue?vue&type=script&lang=ts&"
export * from "./Dev.vue?vue&type=script&lang=ts&"
import style0 from "./Dev.vue?vue&type=style&index=0&id=63c92e78&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports